import { withState } from 'recompose'
import compose from 'lodash/fp/compose'
import VehicleSelector from '../components/VehicleSelector'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import range from 'lodash/range'

const CurrentYearRange = gql`
  query CurrentYearRange {
    getYears {
      min_year
      max_year
    }
  }
`;

const CurrentMakes = gql`
  query CurrentMakes($year: Int!) {
    getMakes(year: $year) {
      id
      name
    }
  }
`

const CurrentModels = gql`
  query CurrentModels($year: Int!, $make: String!) {
    getModels(year: $year, make: $make)
  }
`

const CurrentTrims = gql`
  query CurrentTrims($year: Int!, $make: String!, $model: String!) {
    getTrims(year: $year, make: $make, model: $model)
  }
`

export default compose(
  withState('year', 'setYear', props => props.year || ''),
  graphql(CurrentYearRange, {
    props: ({ ownProps, data }) => ({
      yearsLoading: data.loading,
      options: { years: data.getYears ? range(data.getYears.min_year, data.getYears.max_year) : [] }
    })
  }),
  withState('make', 'setMake', props => props.make || ''),
  graphql(CurrentMakes, {
    skip: ownProps => ownProps.year === '',
    props: ({ ownProps, data }) => ({
      makesLoading: data.loading,
      options: Object.assign({}, ownProps.options, {
        makes: data.getMakes
      })
    })
  }),
  withState('model', 'setModel', props => props.model || ''),
  graphql(CurrentModels, {
    skip: ownProps => ownProps.make === '',
    props: ({ ownProps, data }) => ({
      modelsLoading: data.loading,
      options: Object.assign({}, ownProps.options, {
        models: data.getModels
      })
    })
  }),
  withState('trim', 'setTrim', props => props.trim || ''),
  graphql(CurrentTrims, {
    skip: ownProps => ownProps.model === '',
    props: ({ ownProps, data }) => ({
      trimsLoading: data.loading,
      options: Object.assign({}, ownProps.options, {
        trims: data.getTrims
      })
    })
  })
)(VehicleSelector)




// WEBPACK FOOTER //
// ./src/modules/vehicles/containers/VehicleOptionsSelector.js